import { Zone } from '../../interfaces'
import { ZoneAction } from '../actions/zoneActions'
import { GET_ZONES_EXITO } from '../types/zoneActionsTypes'

export interface ZoneState {
  zonesState: {
    zones?: Zone[] | undefined
    error?: string | undefined
  }
}

const initialState: ZoneState = {
  zonesState: { zones: [], error: '' }
}

export const zoneReducer = (
  state: ZoneState = initialState,
  action: ZoneAction
): ZoneState => {
  if (action.type === GET_ZONES_EXITO) {
    return {
      ...state,
      zonesState: {
        zones: action.zones,
        error: action.error
      }
    }
  }
  return state
}
